export const ConsultationButtonStatus = Object.freeze({
  InProgress: 1,
  StartTranscribing: 2,
  Pause: 3,
  Manual: 4,
  Completed: 5,
  Cancel: 6,
});
